import React from 'react';

/**
 * @typedef {object} PerformanceMetricPageInfoBoxProps
 * @property {boolean} [showDescriptions]
 * @property {Object} [validationErrors]
 * @property {Object} [metricPropertyInfo]
 * @property {boolean} [isViewOnly]
 */

/**
 * @param {PerformanceMetricPageInfoBoxProps} props
 */
const PerformanceMetricPageInfoBox = props => {
  const { showDescriptions, validationErrors, metricPropertyInfo, isViewOnly } = props;

  return (
    <div
      className={'metric-info-box' + (showDescriptions ? ' show' : '')}
      data-testid='metric-info-box'
      onClick={e => {
        e.stopPropagation();
      }}>
      {metricPropertyInfo ? (
        <>
          <h4>{metricPropertyInfo.title}</h4>
          <p>{metricPropertyInfo.description}</p>
          {!isViewOnly && (
            <p>
              {metricPropertyInfo.isEditableAfterSaving
                ? 'Editable after saving.'
                : 'Not editable after saving.'}
            </p>
          )}
          {validationErrors[metricPropertyInfo.field] &&
            validationErrors[metricPropertyInfo.field].hasError &&
            validationErrors[metricPropertyInfo.field].errorMessage && (
              <p className='error-message'>
                {validationErrors[metricPropertyInfo.field].errorMessage}
              </p>
            )}
        </>
      ) : (
        <>
          <span>Click on a field for details.</span>
          <div>
            {Object.keys(validationErrors).map(
              x =>
                validationErrors[x].hasError &&
                validationErrors[x].errorMessage && (
                  <p key={x} className='error-message'>
                    <br />
                    {validationErrors[x].title + ' - ' + validationErrors[x].errorMessage}
                  </p>
                )
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default PerformanceMetricPageInfoBox;
